module.exports = __webpack_public_path__ + "img/20221206171929536icj.58c26d64.jpg";